import React, { InputHTMLAttributes, useState } from "react";
import { colors, fontSizing, spacing } from "../../theme";
import styled from "styled-components";
import { Error, InfoSpan, InputWrap, Label } from "./Input";
import { ArrowRight, Caret } from "../../common/icons";

type Props = InputHTMLAttributes<HTMLSelectElement> & {
  children: any;
  error?: string;
  initialFilled?: boolean;
  info?: string;
  label?: string;
};

const Select = styled.select<{ error?: boolean }>`
  appearance: none;
  height: 71px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  ${spacing("padding-top", 32)}
  ${spacing("padding-bottom", 32)}
  ${spacing("padding-left", 48)}
  ${spacing("padding-right", 48)}
  
  ${fontSizing("label", 20)}
  color: ${p => (p.error ? colors.errorRed : colors.blue)};
  background: #fff;


  &[disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &[readOnly] {
    color: ${colors.darkgrey};
    cursor: not-allowed;
  }
  &::placeholder {
    color: ${colors.pigeon};
    font-size: 1em;
  }

  ::-ms-expand {
    display: none; // hide the arrow in IE10 and up
  }

  :hover {
    border-bottom-color: ${colors.blue};
  }

  :focus {
    outline: none;
    border-bottom-color: ${colors.blue};
    ::-ms-value {
      background-color: ${colors.white};
      color: ${colors.grey};
    }
  }

  [disabled] {
    color: ${colors.whiteThree};
  }
`;

const Rel = styled.div`
  position: relative;
`;

const CaretWrapper = styled.span`
  display: inline-block;
  position: absolute;
  right: 28px;
  top: calc(50% - 14px);
  pointer-events: none;
`;

export const Dropdown: React.FC<Props> = p => {
  const [blockCollapse, setBlockCollapse] = useState<boolean>(false);
  const { error, label, info, id, ...props } = p;
  return (
    <>
      <InputWrap>
        {(label || info) && (
          <Label
            disabled={props.disabled}
            readOnly={props.readOnly}
            htmlFor={id}
          >
            {label && label}
          </Label>
        )}
        <Rel>
          <Select {...props} onChange={props.onChange} id={id} />
          <CaretWrapper>
            <Caret isRotate={blockCollapse} error={!!error} />
          </CaretWrapper>
        </Rel>
        {(error || info) && (
          <Error isError={!!error}>{info ? info : error}</Error>
        )}
      </InputWrap>
    </>
  );
};

interface OptionProps {
  children: string | number;
  value?: string | number;
  disabled?: boolean;
  selected?: boolean;
  hidden?: boolean;
}
export function DropdownOption(props: OptionProps) {
  return (
    <option
      hidden={props.hidden}
      selected={props.selected}
      disabled={props.disabled}
      value={props.value ? props.value : props.children}
    >
      {props.children}
    </option>
  );
}

export default Dropdown;
